import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoggedIn: false,
    drawerOpen: false,
    user: null,
    token: null,
    isLoading: false,
}

const common = createSlice({
    name: 'common',
    initialState,
    reducers: {
        handleDrawerOpen(state) {
            state.drawerOpen = true;
        },
        handleDrawerClose(state) {
            state.drawerOpen = false;
        },
        setToken(state, action) {
            state.token = action.payload;
            state.isLoggedIn = true;
            state.drawerOpen = true;
        },
        setLogout(state) {
            state.isLoggedIn = false;
            state.token = null;
            state.user = null;
        },
        setUser(state, action) {
            state.user = action.payload;
        },
        trueIsLoading(state) {
            state.isLoading = true;
        },
        falseIsLoading(state) {
            state.isLoading = false;
        },
    }
})

export const commonActions = common.actions;
export default common;